const modelNodes = {
  initial: [0, 2, 3, 4, 5, 6, 21, 22, 23, 137, 138, 139, 856, 857, 858],
  "1.6m": {
    nodes: [0, 2, 3, 4, 5, 6, 21, 22, 23, 137, 138, 139, 856, 857, 858],
    heater: {
      Internal: {
        nodes: [210, 211, 212, 224, 225, 226, 238, 239, 240, 248],
        upgrades: {
          "Cover Around Internal Heater": {
            nodes: [182, 183, 184],
          },
        },
        interiorexterior: {
          "Wooden Bench": {
            nodes: [151, 152, 153],
          },
          "Polypropylene Bench": {
            nodes: [663, 664, 665],
          },
          "Polypropylene Closed Bench": {
            nodes: [708, 709, 710],
          },
        },
        flueDrain: {
          "Chimney Heat Guard": {
            nodes: [412, 413, 414],
          },
        },
        lidCover: {
          Wooden: {
            nodes: [264, 265, 266],
          },
        },
        wooden: {
          "Mini Bar / Drink Holder": {
            nodes: [196, 197, 198],
          },
        },
      },
      External: {
        Standard: {
          nodes: [909, 910, 911, 919, 927],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [1143, 1144, 1145, 1153, 1161],
              initial: [1041, 1042, 1043, 1051],
            },
            "90-Degree Heater Connections": {
              nodes: [360, 361, 362, 370, 378],
              initial: [909, 910, 911, 919, 927],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [454, 455, 456],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [625, 626, 627, 635, 643],
                  initial: [520, 521, 522, 530],
                },
              },
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [975, 976, 977],
            },
          },
          interiorexterior: {
            liner: {
              nodes: [842, 843, 844, 109, 110, 111, 123, 124, 125],
              //165, 166, 167, 109, 110, 111, 123, 124, 125
            },
          },
        },
        Medium: {
          nodes: [1181, 1182, 1183, 1191, 1199],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [1105, 1106, 1107, 1115, 1123],
              initial: [1015, 1016, 1017, 1025],
            },
            "90-Degree Heater Connections": {
              nodes: [322, 323, 324, 332, 340],
              initial: [1181, 1182, 1183, 1191, 1199],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [440, 441, 442],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [587, 588, 589, 597, 605],
                  initial: [494, 495, 496, 504],
                },
              },
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [961, 962, 963],
            },
          },
          interiorexterior: {
            liner: {
              nodes: [842, 843, 844, 109, 110, 111, 123, 124, 125],
              //165, 166, 167, 109, 110, 111, 123, 124, 125
            },
          },
        },
        Large: {
          nodes: [871, 872, 873, 881, 889],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [1067, 1068, 1069, 1077, 1085],
              initial: [989, 990, 991, 999],
            },
            "90-Degree Heater Connections": {
              nodes: [278, 279, 280, 288, 299],
              initial: [871, 872, 873, 881, 889],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [426, 427, 428],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [546, 547, 548, 556, 564],
                  initial: [468, 469, 470, 478],
                },
              },
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [947, 948, 949],
            },
          },
          interiorexterior: {
            liner: {
              nodes: [842, 843, 844, 109, 110, 111, 123, 124, 125],
              //165, 166, 167, 109, 110, 111, 123, 124, 125
            },
          },
        },
      },
    },
    interiorexterior: {
      liner: {
        nodes: [842, 843, 844, 109, 110, 111, 123, 124, 125],
      },
      seating: {
        "Wooden Bench": {
          nodes: [398, 399, 400],
        },
        "Polypropylene Bench": {
          nodes: [678, 679, 680],
          initial: [398, 399, 400],
        },
        "Polypropylene Closed Bench": {
          nodes: [693, 694, 695],
          initial: [398, 399, 400],
        },
      },
      lidCover: {
        Wooden: {
          nodes: [754, 755, 756],
        },
        Insulated: {
          nodes: [797, 798, 799],
        },
        "No Cover": {
          nodes: [],
        },
      },
    },
    accessories: {
      flueDrain: {
        "High-Flow Drain Tap": {
          nodes: [53, 54, 55, 63, 71, 82],
        },
      },
      wooden: {
        "Mini Bar / Drink Holder": {
          nodes: [783, 784, 785],
        },
        "Top Rim Decoration": {
          nodes: [109, 110, 111, 123, 124, 125],
        },
        "Stirring Paddle": {
          nodes: [814, 815, 816],
        },
        "Wide Bespoke Steps": {
          nodes: [723, 724, 725],
          initial: [137, 138, 139],
        },
      },
      electrical: {
        "LED Underwater Lighting": {
          "1 LED Light": {
            nodes: [1233, 1234, 1235, 1243, 1254],
          },
          "2 LED Lights": {
            nodes: [1233, 1234, 1235, 1243, 1254],
          },
          "3 LED Lights": {
            nodes: [1233, 1234, 1235, 1243, 1254],
          },
        },
        "Combined Massage System": {
          nodes: [
            1327, 1328, 1329, 1337, 1345, 1353, 1427, 1428, 1429, 1437, 1445,
            1453, 1403, 1477, 1478, 1479,
          ],
        },
        "Hydro Massage System": {
          "1.1kW with 6 jets": {
            nodes: [1327, 1328, 1329, 1337, 1345, 1353, 1477, 1478, 1479],
          },
          "2.2kW with 10 jets": {
            nodes: [1327, 1328, 1329, 1337, 1345, 1353, 1477, 1478, 1479],
          },
        },
        "Air Bubble System": {
          nodes: [1427, 1428, 1429, 1437, 1445, 1453, 1403, 1477, 1478, 1479],
          //nodes for 8x: 1377, 1378, 1379, 1387, 1395
        },
      },
    },
  },
  "1.8m": {
    nodes: [
      0, 2, 1618, 1633, 1634, 1635, 1647, 1648, 1649, 1661, 1662, 1663, 1675,
      1676, 1677, 1689, 1690, 1691, 2470, 2471, 2472,
    ],
    heater: {
      Internal: {
        nodes: [1817, 1818, 1819, 1827, 1619, 1620, 1621, 1789, 1790, 1791],
        upgrades: {
          "Cover Around Internal Heater": {
            nodes: [1803, 1804, 1805],
          },
        },
        interiorexterior: {
          "Wooden Bench": {
            nodes: [2021, 2022, 2023],
          },
          "Polypropylene Bench": {
            nodes: [2299, 2300, 2301],
          },
          "Polypropylene Closed Bench": {
            nodes: [2427, 2428, 2429],
          },
        },
        flueDrain: {
          "Chimney Heat Guard": {
            nodes: [2036, 2037, 2038],
          },
        },
        lidCover: {
          Wooden: {
            nodes: [1718, 1719, 1720],
          },
        },
        wooden: {
          "Mini Bar / Drink Holder": {
            nodes: [1775, 1776, 1777],
          },
        },
      },
      External: {
        Standard: {
          nodes: [2523, 2524, 2525, 2533, 2541],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [2757, 2758, 2759, 2767, 2775],
              initial: [2655, 2656, 2657, 2665],
            },
            "90-Degree Heater Connections": {
              nodes: [1983, 1984, 1985, 1993, 2001],
              initial: [2523, 2524, 2525, 2533, 2541],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [2064, 2065, 2066],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [2246, 2247, 2248, 2256, 2264],
                  initial: [2144, 2145, 2146, 2154],
                },
              },
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [2589, 2590, 2591],
            },
          },
          interiorexterior: {
            liner: {
              nodes: [1732, 1733, 1734, 1746, 1747, 1748, 2456, 2457, 2458],
            },
          },
        },
        Medium: {
          nodes: [2795, 2796, 2797, 2805, 2813],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [2719, 2720, 2721, 2729, 2737],
              initial: [2626, 2630, 2631, 2639],
            },
            "90-Degree Heater Connections": {
              nodes: [1945, 1946, 1947, 1955, 1963],
              initial: [2795, 2796, 2797, 2805, 2813],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [2078, 2079, 2080],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [2208, 2209, 2210, 2218, 2226],
                  initial: [2118, 2119, 2120, 2128],
                },
              },
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [2575, 2576, 2577],
            },
          },
          interiorexterior: {
            liner: {
              nodes: [1732, 1733, 1734, 1746, 1747, 1748, 2456, 2457, 2458],
            },
          },
        },
        Large: {
          nodes: [2485, 2486, 2487, 2495, 2503],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [2681, 2682, 2683, 2691, 2699],
              initial: [2603, 2604, 2605, 2613],
            },
            "90-Degree Heater Connections": {
              nodes: [1907, 1908, 1909, 1917, 1925],
              initial: [2485, 2486, 2487, 2495, 2503],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [2050, 2051, 2052],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [2170, 2171, 2172, 2180, 2188],
                  initial: [2092, 2093, 2094, 2102],
                },
              },
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [2561, 2562, 2563],
            },
          },
          interiorexterior: {
            liner: {
              nodes: [1732, 1733, 1734, 1746, 1747, 1748, 2456, 2457, 2458],
            },
          },
        },
      },
    },
    interiorexterior: {
      liner: {
        nodes: [1732, 1733, 1734, 1746, 1747, 1748, 2456, 2457, 2458],
      },
      seating: {
        "Wooden Bench": {
          nodes: [1760, 1761, 1762],
        },
        "Polypropylene Bench": {
          nodes: [2284, 2285, 2286],
        },
        "Polypropylene Closed Bench": {
          nodes: [2412, 2413, 2414],
        },
      },
      lidCover: {
        Wooden: {
          nodes: [2342, 2343, 2344],
        },
        Insulated: {
          nodes: [2384, 2385, 2386],
        },
        "No Cover": {
          nodes: [],
        },
      },
    },
    accessories: {
      flueDrain: {
        "High-Flow Drain Tap": {
          nodes: [1843, 1844, 1845, 1853, 1861, 1869],
        },
      },
      wooden: {
        "Mini Bar / Drink Holder": {
          nodes: [2370, 2371, 2372],
        },
        "Top Rim Decoration": {
          nodes: [1732, 1733, 1734, 1746, 1747, 1748],
        },
        "Stirring Paddle": {
          nodes: [2398, 2399, 2400],
        },
        "Wide Bespoke Steps": {
          nodes: [2314, 2315, 2316],
          initial: [1647, 1648, 1649],
        },
      },
      electrical: {
        "LED Underwater Lighting": {
          "1 LED Light": {
            nodes: [2847, 2848, 2849, 2857, 2865],
          },
          "2 LED Lights": {
            nodes: [2847, 2848, 2849, 2857, 2865],
          },
          "3 LED Lights": {
            nodes: [2847, 2848, 2849, 2857, 2865],
          },
        },
        "Combined Massage System": {
          nodes: [2935, 2936, 2937, 2945, 2953, 2961, 3085, 3086, 3087],
        },
        "Hydro Massage System": {
          "1.1kW with 6 jets": {
            nodes: [
              3035, 3036, 3037, 3045, 3053, 3061, 2935, 2936, 2937, 2945, 2953,
              2961, 3085, 3086, 3087
            ],
          },
          "2.2kW with 10 jets": {
            nodes: [3035, 3036, 3037, 3045, 3053, 3061, 2935, 2936, 2937, 2945, 2953,
              2961, 3085, 3086, 3087],
          },
        },
        "Air Bubble System": {
          nodes: [3035, 3036, 3037, 3045, 3053, 3061, 3085, 3086, 3087],
          //nodes for 4x: 2985, 2986, 2987, 2995, 3003, 3011
        },
      },
    },
  },
  "2.0m": {
    nodes: [
      0, 2, 3099, 3126, 3127, 3128, 3168, 3169, 3170, 3182, 3183, 3184, 3196,
      3197, 3198, 3210, 3211, 3212, 3949, 3950, 3951,
    ],
    heater: {
      Internal: {
        nodes: [3100, 3101, 3102, 3110, 3281, 3282, 3283, 3295, 3296, 3297],
        upgrades: {
          "Cover Around Internal Heater": {
            nodes: [3267, 3268, 3269],
          },
        },
        interiorexterior: {
          "Wooden Bench": {
            nodes: [3238, 3239, 3240],
          },
          "Polypropylene Bench": {
            nodes: [3763, 3764, 3765],
          },
          "Polypropylene Closed Bench": {
            nodes: [3906, 3907, 3908],
          },
        },
        flueDrain: {
          "Chimney Heat Guard": {
            nodes: [3515, 3516, 3517],
          },
        },
        lidCover: {
          Wooden: {
            nodes: [3373, 3374, 3375],
          },
        },
        wooden: {
          "Mini Bar / Drink Holder": {
            nodes: [3224, 3225, 3226],
          },
        },
      },
      External: {
        Standard: {
          nodes: [4002, 4003, 4004, 4012, 4020],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [4236, 4237, 4238, 4246, 4254],
              initial: [4134, 4135, 4136, 4144],
            },
            "90-Degree Heater Connections": {
              nodes: [3463, 3464, 3465, 3473, 3481],
              initial: [4002, 4003, 4004, 4012, 4020],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [3557, 3558, 3559],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [3725, 3726, 3727, 3735, 3743],
                  initial: [3623, 3624, 3625, 3633],
                },
              },
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [4068, 4069, 4070],
            },
          },
          interiorexterior: {
            liner: {
              nodes: [3140, 3141, 3142, 3154, 3155, 3156, 3309, 3310, 3311],
            },
          },
        },
        Medium: {
          nodes: [4274, 4275, 4276, 4284, 4292],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [4198, 4199, 4200, 4208, 4216],
              initial: [4108, 4109, 4110, 4118],
            },
            "90-Degree Heater Connections": {
              nodes: [3425, 3426, 3427, 3435, 3443],
              initial: [4274, 4275, 4276, 4284, 4292],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [3543, 3544, 3545],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [3687, 3688, 3689, 3697, 3705],
                  initial: [3597, 3598, 3599, 3607],
                },
              },
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [4054, 4055, 4056],
            },
          },
          interiorexterior: {
            liner: {
              nodes: [3140, 3141, 3142, 3154, 3155, 3156, 3309, 3310, 3311],
            },
          },
        },
        Large: {
          nodes: [3964, 3965, 3966, 3974, 3982],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [4160, 4161, 4162, 4170, 4178],
              initial: [4082, 4083, 4084, 4092],
            },
            "90-Degree Heater Connections": {
              nodes: [3387, 3388, 3389, 3397, 3405],
              initial: [3964, 3965, 3966, 3974, 3982],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [3529, 3530, 3531],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [3649, 3650, 3651, 3659, 3667],
                  initial: [3571, 3572, 3573, 3581],
                },
              },
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [4040, 4041, 4042],
            },
          },
          interiorexterior: {
            liner: {
              nodes: [3140, 3141, 3142, 3154, 3155, 3156, 3309, 3310, 3311],
            },
          },
        },
      },
    },
    interiorexterior: {
      liner: {
        nodes: [3140, 3141, 3142, 3154, 3155, 3156, 3309, 3310, 3311],
      },
      seating: {
        "Wooden Bench": {
          nodes: [3501, 3502, 3503],
        },
        "Polypropylene Bench": {
          nodes: [3778, 3779, 3780],
        },
        "Polypropylene Closed Bench": {
          nodes: [3891, 3892, 3893],
        },
      },
      lidCover: {
        Wooden: {
          nodes: [3821, 3822, 3823],
        },
        Insulated: {
          nodes: [3863, 3864, 3865],
        },
        "No Cover": {
          nodes: [],
        },
      },
    },
    accessories: {
      flueDrain: {
        "High-Flow Drain Tap": {
          nodes: [3323, 3324, 3325, 3333, 3341, 3349],
        },
      },
      wooden: {
        "Mini Bar / Drink Holder": {
          nodes: [3849, 3850, 3851],
        },
        "Top Rim Decoration": {
          nodes: [3140, 3141, 3142, 3154, 3155, 3156],
        },
        "Stirring Paddle": {
          nodes: [3877, 3878, 3879],
        },
        "Wide Bespoke Steps": {
          nodes: [3793, 3794, 3795],
          initial: [3126, 3127, 3128],
        },
      },
      electrical: {
        "LED Underwater Lighting": {
          "1 LED Light": {
            nodes: [4326, 4327, 4328, 4336, 4344],
          },
          "2 LED Lights": {
            nodes: [4326, 4327, 4328, 4336, 4344],
          },
          "3 LED Lights": {
            nodes: [4326, 4327, 4328, 4336, 4344],
          },
        },
        "Combined Massage System": {
          nodes: [
            4514, 4515, 4516, 4524, 4532, 4540, 4414, 4415, 4416, 4424, 4432,
            4440, 4564, 4565, 4566,
          ],
        },
        "Hydro Massage System": {
          "1.1kW with 6 jets": {
            nodes: [4414, 4415, 4416, 4424, 4432, 4440, 4564, 4565, 4566],
          },
          "2.2kW with 10 jets": {
            nodes: [4414, 4415, 4416, 4424, 4432, 4440, 4564, 4565, 4566],
          },
        },
        "Air Bubble System": {
          nodes: [4514, 4515, 4516, 4524, 4532, 4540, 4564, 4565, 4566],
          //nodes for 4x: 4464, 4465, 4466, 4474, 4482, 4490
        },
      },
    },
  },
  "2.2m": {
    nodes: [
      0, 2, 4578, 4579, 4580, 4581, 4593, 4594, 4595, 4607, 4608, 4609, 4621,
      4622, 4623, 4661, 4662, 4663, 5427, 5428, 5429,
    ],
    heater: {
      Internal: {
        nodes: [4717, 4718, 4719, 4745, 4746, 4747, 4755, 4771, 4772, 4773],
        upgrades: {
          "Cover Around Internal Heater": {
            nodes: [4731, 4732, 4733],
          },
        },
        interiorexterior: {
          "Wooden Bench": {
            nodes: [4675, 4676, 4677],
          },
          "Polypropylene Bench": {
            nodes: [5253, 5254, 5255],
          },
          "Polypropylene Closed Bench": {
            nodes: [5398, 5399, 5400],
          },
        },
        lidCover: {
          Wooden: {
            nodes: [4977, 4978, 4979],
          },
        },
        flueDrain: {
          "Chimney Heat Guard": {
            nodes: [5005, 5006, 5007],
          },
        },
        wooden: {
          "Mini Bar / Drink Holder": {
            nodes: [4703, 4704, 4705],
          },
        },
      },
      External: {
        Standard: {
          nodes: [5479, 5480, 5481, 5489, 5497],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [5713, 5714, 5715, 5723, 5731],
              initial: [5611, 5612, 5613, 5621],
            },
            "90-Degree Heater Connections": {
              nodes: [4875, 4876, 4877, 4885, 4893],
              initial: [5479, 5480, 5481, 5489, 5497],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [5047, 5048, 5049],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [5215, 5216, 5217, 5225, 5233],
                  initial: [5113, 5114, 5115, 5123],
                },
              },
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [5545, 5546, 5547],
            },
          },
          interiorexterior: {
            liner: {
              nodes: [4689, 4690, 4691, 4963, 4964, 4965, 5803, 5804, 5805],
            },
          },
        },
        Medium: {
          nodes: [5751, 5752, 5753, 5761, 5769],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [5675, 5676, 5677, 5685, 5693],
              initial: [5585, 5586, 5587, 5595],
            },
            "90-Degree Heater Connections": {
              nodes: [4837, 4838, 4839, 4847, 4855],
              initial: [5751, 5752, 5753, 5761, 5769],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [5019, 5020, 5021],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [5177, 5178, 5179, 5187, 5195],
                  initial: [5087, 5088, 5089, 5097],
                },
              },
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [5531, 5532, 5533],
            },
          },
          interiorexterior: {
            liner: {
              nodes: [4689, 4690, 4691, 4963, 4964, 4965, 5803, 5804, 5805],
            },
          },
        },
        Large: {
          nodes: [5441, 5442, 5443, 5451, 5459],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [5637, 5638, 5639, 5647, 5655],
              initial: [5559, 5560, 5561, 5569],
            },
            "90-Degree Heater Connections": {
              nodes: [4799, 4800, 4801, 4809, 4817],
              initial: [5441, 5442, 5443, 5451, 5459],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [5033, 5034, 5035],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [5139, 5140, 5141, 5149, 5157],
                  initial: [5061, 5062, 5063, 5071],
                },
              },
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [5517, 5518, 5519],
            },
          },
          interiorexterior: {
            liner: {
              nodes: [4689, 4690, 4691, 4963, 4964, 4965, 5803, 5804, 5805],
            },
          },
        },
      },
    },
    interiorexterior: {
      liner: {
        nodes: [4689, 4690, 4691, 4963, 4964, 4965, 5803, 5804, 5805],
      },
      seating: {
        "Wooden Bench": {
          nodes: [4991, 4992, 4993],
        },
        "Polypropylene Bench": {
          nodes: [5269, 5270, 5271],
        },
        "Polypropylene Closed Bench": {
          nodes: [5383, 5384, 5385],
        },
      },
      lidCover: {
        Wooden: {
          nodes: [5313, 5314, 5315],
        },
        Insulated: {
          nodes: [5355, 5356, 5357],
        },
        "No Cover": {
          nodes: [],
        },
      },
    },
    accessories: {
      flueDrain: {
        "High-Flow Drain Tap": {
          nodes: [4913, 4914, 4915, 4923, 4931, 4939],
        },
      },
      wooden: {
        "Mini Bar / Drink Holder": {
          nodes: [5341, 5342, 5343],
        },
        "Top Rim Decoration": {
          nodes: [4689, 4690, 4691, 4963, 4964, 4965],
        },
        "Stirring Paddle": {
          nodes: [5369, 5370, 5371],
        },
        "Wide Bespoke Steps": {
          nodes: [5285, 5286, 5287],
          initial: [4579, 4580, 4581],
        },
      },
      electrical: {
        "LED Underwater Lighting": {
          "1 LED Light": {
            nodes: [5817, 5818, 5819, 5827, 5835],
          },
          "2 LED Lights": {
            nodes: [5817, 5818, 5819, 5827, 5835],
          },
          "3 LED Lights": {
            nodes: [5817, 5818, 5819, 5827, 5835],
          },
        },
        "Combined Massage System": {
          nodes: [
            5905, 5906, 5907, 5915, 5923, 5931, 6005, 6006, 6007, 6015, 6023,
            6031, 6055, 6056, 6057,
          ],
        },
        "Hydro Massage System": {
          "1.1kW with 6 jets": {
            nodes: [5905, 5906, 5907, 5915, 5923, 5931, 6055, 6056, 6057],
          },
          "2.2kW with 10 jets": {
            nodes: [5905, 5906, 5907, 5915, 5923, 5931, 6055, 6056, 6057],
          },
        },
        "Air Bubble System": {
          nodes: [6005, 6006, 6007, 6015, 6023, 6031, 6055, 6056, 6057],
          //nodes for 4x: 5955, 5956, 5957, 5965, 5973, 5981
        },
      },
    },
  },
};

export default modelNodes;
